"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var PropTypes = __importStar(require("prop-types"));

var React = __importStar(require("react"));

var withTheme_1 = require("../utils/withTheme");

var rxjs_1 = require("rxjs");

var SafeAsyncComponent_1 = __importDefault(require("./SafeAsyncComponent"));

var operators_1 = require("rxjs/operators");
/**
 * Renders a spinner and adds a screen reader description if the loader
 * is still visible after 5 seconds. Combines the prop `visible` with an
 * RXJS observeble/timer to determ if the aria-live text should be added.
 */


var Loader =
/** @class */
function (_super) {
  __extends(Loader, _super);

  function Loader(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      ariaLiveVisible: false
    };
    _this.visible$ = new rxjs_1.Subject();
    _this.ariaLiveSubscription = _this.visible$.pipe(operators_1.distinctUntilChanged(),
    /*
        Debounce 5 seconds if the spinner is visible.
        If not, resolve immediately.
    */
    operators_1.debounce(function (visible) {
      return rxjs_1.timer(visible ? 5000 : 0);
    })).subscribe(function (isStillVisible) {
      _this.setState({
        ariaLiveVisible: isStillVisible
      });
    });
    return _this;
  }

  Loader.prototype.shouldComponentUpdate = function (nextProps, nextState) {
    return this.props.visible !== nextProps.visible || this.state.ariaLiveVisible !== nextState.ariaLiveVisible;
  };

  Loader.prototype.safeComponentDidMount = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        this.visible$.next(this.props.visible);
        return [2
        /*return*/
        ];
      });
    });
  };

  Loader.prototype.safeComponentDidUpdate = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        this.visible$.next(this.props.visible);
        return [2
        /*return*/
        ];
      });
    });
  };

  Loader.prototype.safeComponentWillUnmount = function () {
    this.ariaLiveSubscription.unsubscribe();
  };

  Loader.prototype.render = function () {
    return withTheme_1.withTheme(this.context.theme, {
      loader: true,
      'loader--is-visible': this.props.visible
    })(React.createElement("div", {
      "aria-hidden": !this.props.visible
    }, this.state.ariaLiveVisible && React.createElement("span", {
      "aria-live": "assertive",
      "aria-label": "Videon laddar"
    })));
  };

  Loader.contextTypes = {
    theme: PropTypes.object,
    throwError: PropTypes.func
  };
  return Loader;
}(SafeAsyncComponent_1["default"]);

exports["default"] = Loader;